"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useDeleteDialog } from "../Providers/DeleteDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { deleteDialogOpen, closeDeleteDialog } = useDeleteDialog();

  return (
    <MuiDialog open={deleteDialogOpen} onClose={closeDeleteDialog}>
      {children}
    </MuiDialog>
  );
}
